
import React from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { useLanguage } from '@/components/i18n/language-provider';
import ComparisonTableRow from './ComparisonTableRow';

const ComparisonTable: React.FC = () => {
  const { t } = useLanguage();
  
  const features = [
    {
      feature: 'Passwordless Authentication',
      keystle: { icon: 'check' as const, text: 'Comprehensive native support' },
      auth0: { icon: 'alert' as const, text: 'Limited to premium tiers' },
      keycloak: { icon: 'alert' as const, text: 'Requires custom integration' },
    },
    {
      feature: 'Multi-Factor Authentication',
      keystle: { icon: 'check' as const, text: 'Included in all tiers' },
      auth0: { icon: 'alert' as const, text: 'Enterprise plan only' },
      keycloak: { icon: 'x' as const, text: 'Third-party integration required' },
    },
    {
      feature: 'Multi-Tenant Architecture',
      keystle: { icon: 'check' as const, text: 'True tenant isolation' },
      auth0: { icon: 'alert' as const, text: 'Complex implementation in premium tiers' },
      keycloak: { icon: 'alert' as const, text: 'Extensive configuration needed' },
    },
    {
      feature: 'Analytics & Monitoring',
      keystle: { icon: 'check' as const, text: 'Comprehensive real-time insights' },
      auth0: { icon: 'check' as const, text: '' },
      keycloak: { icon: 'x' as const, text: 'Requires third-party tools' },
    },
    {
      feature: 'Privacy Compliance',
      keystle: { icon: 'check' as const, text: 'Fully compliant out-of-box' },
      auth0: { icon: 'check' as const, text: '' },
      keycloak: { icon: 'alert' as const, text: 'Manual configuration required' },
    },
    {
      feature: 'Access Control Models',
      keystle: { icon: 'check' as const, text: 'RBAC, ABAC, PBAC supported' },
      auth0: { icon: 'alert' as const, text: 'Limited without OPA integration' },
      keycloak: { icon: 'alert' as const, text: 'Basic implementation' },
    },
    {
      feature: 'Developer Experience',
      keystle: { icon: 'check' as const, text: 'Comprehensive APIs with detailed docs' },
      auth0: { icon: 'check' as const, text: '' },
      keycloak: { icon: 'alert' as const, text: 'Complex learning curve' },
    },
    {
      feature: 'Social Authentication',
      keystle: { icon: 'check' as const, text: 'Seamless provider integration' },
      auth0: { icon: 'check' as const, text: '' },
      keycloak: { icon: 'alert' as const, text: 'Additional extensions needed' },
    },
    {
      feature: 'Pricing Structure',
      keystle: { icon: 'check' as const, text: 'Transparent, usage-based pricing' },
      auth0: { icon: 'x' as const, text: 'Feature gating across tiers' },
      keycloak: { icon: 'check' as const, text: 'Open-source (support costs extra)' },
    },
  ];

  return (
    <div className="overflow-x-auto mb-12">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-1/4">{t('Feature')}</TableHead>
            <TableHead className="w-1/4 bg-primary/5">{t('Keystle')}</TableHead>
            <TableHead className="w-1/4">{t('Auth0')}</TableHead>
            <TableHead className="w-1/4">{t('Keycloak')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {features.map((feature, index) => (
            <ComparisonTableRow
              key={index}
              feature={feature.feature}
              keystle={feature.keystle}
              auth0={feature.auth0}
              keycloak={feature.keycloak}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ComparisonTable;
